import { render, staticRenderFns } from "./ThemePreview.vue?vue&type=template&id=f745d6d6&scoped=true"
import script from "./ThemePreview.vue?vue&type=script&lang=js"
export * from "./ThemePreview.vue?vue&type=script&lang=js"
import style0 from "./ThemePreview.vue?vue&type=style&index=0&id=f745d6d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f745d6d6",
  null
  
)

export default component.exports